module.exports = __webpack_public_path__ + "img/coins-agree-confirm.ea194f1b.png";